import { Box } from "@mui/material";
import { AppRouter } from "./Route/AppRouter";

function App() {
  return (
    <Box>
      <AppRouter/>
    </Box>
  );
}

export default App;
